import React from 'react';
import './SelectedProductCarousel.css';
import ProductDetails from './ProductDetails';

function SelectedProductCarousel({ products, selectedProduct, setSelectedProduct,getProductSku }) {


    return (
        <>
            <div className='main-carousel-container'>
                <div className='carousel-viewport'>
                    <div className='carousel-wrapper'>
                        {products?.map((element, index) => (
                            <ProductDetails
                                key={element.sku}
                                product={element}
                                selectedProduct={selectedProduct}
                                setSelectedProduct={setSelectedProduct}
                                getProductSku={getProductSku}
                                
                            />

                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SelectedProductCarousel